import template from './fatalErrors.html';
import controller from './fatalErrorsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fatalErrorsData: '<',
  },
};
